import { render } from "./LostItemDetails.vue?vue&type=template&id=5eaaffd7"
import script from "./LostItemDetails.vue?vue&type=script&lang=js"
export * from "./LostItemDetails.vue?vue&type=script&lang=js"

import "./LostItemDetails.vue?vue&type=style&index=0&id=5eaaffd7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__